export default {
  alert: {
    alert20: "#fff6f7",
    alert40: "#f7e0e0",
    alert60: "#ffd1d7",
    alert80: "#ebb1b1",
    alert100: "#ff4560"
  },
  background: {
    background25: "#f8f8f8",
    background50: "",
    background100: "#161616",
    overlay: "rgba(4, 4, 15, 0.7)"
  },
  black: "#000000",
  blue: {
    blue5: "#F3F8FF",
    blue10: "#C8DFF1",
    blue75: "#5F9AC8",
    blue100: "#006FB7",
    blue120: "#005D9A"
  },
  green: {
    green25: "#f7fbf3",
    green50: "#d2e1a3",
    green100: "#a5c348"
  },
  grey: {
    grey25: "#f2f2f2",
    grey50: "#E6E6E6",
    grey100: "#BFBFBF",
    darker: "#707070"
  },
  primary: "#00321E",
  secondary: "",
  success: {
    success25: "#4e9a55",
    success50: "#4e9a55",
    success100: "#4e9a55"
  },
  warning: {
    warning25: "#fff0cc",
    warning50: "#ffd97f",
    warning100: "#fbbc44"
  },
  white: "#ffffff"
};